import React from 'react';

import appSettings from '../../config/settings';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

import { LayoutSingleColumn } from '../../components';
import css from './MaintenanceMode.module.css';

// MaintenanceMode component is shown when mandatory app-wide configurations are not found from assets.
// Note 1: its text comes from the built-in en.json, which doesn't depend on fetched assets.
// Note 2: In the LandingPage directory, there's a similar content (FallbackPage.js).
const MaintenanceMode = props => {
  const intl = useIntl();
  const isDev = appSettings.dev;
  return (
    <LayoutSingleColumn
      mainColumnClassName={css.layoutWrapperMain}
      topbar={
        <div
          className={css.header}
          title={intl.formatMessage({ id: 'MaintenanceMode.title' })}
        ></div>
      }
      footer={null}
    >
      <section id="content" className={css.root}>
        <div className={css.content}>
          <h2>
            <FormattedMessage id="MaintenanceMode.title" />
          </h2>
          <p>
            <FormattedMessage id="MaintenanceMode.info" />
          </p>
          {isDev ? (
            <>
              <p>
                <FormattedMessage id="MaintenanceMode.devCheckAssets" />
              </p>
              <p>
                <FormattedMessage id="MaintenanceMode.devCheckConsole" />
              </p>
            </>
          ) : (
            <p>
              <FormattedMessage id="MaintenanceMode.howToProceed" />
            </p>
          )}
        </div>
      </section>
    </LayoutSingleColumn>
  );
};

export default MaintenanceMode;
